package org.hs_soft.runmynesto.pages.components.grid_function

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme

import org.hs_soft.runmynesto.domain.config.generalDialogSetting
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.home.template.GridItemsFilterEnum
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomRadioInput
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.components.dialog.component.DialogTitle
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.dom.RadioGroup

@OptIn(ExperimentalComposeWebApi::class)
@Composable
fun FilterActiveGridContent(
    selectedFilterType: GridItemsFilterEnum,
    selectFilterType:(GridItemsFilterEnum)->Unit,
    submitFilterItems:()->Unit,
    onCloseFilterClick:()->Unit,
)
{
    Column(
        modifier = Modifier
            .margin(top = Dimen.smallPadding)
            .fillMaxWidth()
            .height(Dimen.filterGridDialogHeight)
            .generalDialogSetting()
            .zIndex(Constants.ZIndex.extraLargeZIndex)

    ) {

        DialogTitle(
            title = Strings.current().filter,
            showCloseIcon = true,
            showSeparator = false,
            color = Theme.PrimaryMain.rgb,
            fontSize =FontSizes.semiLargeFontSize,
            fontWeight = FontWeight.SemiBold,
            onCloseClick = {
                onCloseFilterClick()
            }
        )

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .fillMaxHeight()
                .weight(1f)
                .padding(Dimen.extraLargePadding,)
        )
        {
            Column(
                modifier = Modifier
            )
            {
                RadioGroup(selectedFilterType.title) {
                    GridItemsFilterEnum.entries.forEach { filter ->
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier
                                .height(Dimen.radioButtonRowHeight)
                                .cursor(Cursor.Pointer)
                                .onClick {
                                    if (filter!=selectedFilterType)
                                        selectFilterType(filter)
                                }
                        )
                        {
                            CustomRadioInput(
                                title = filter.title,
                                checked = filter==selectedFilterType,
                                onClick = {
                                    if (filter!=selectedFilterType)
                                        selectFilterType(filter)
                                },

                            )


                        }


                    }
                }
            }

            Spacer()

            CustomButton(
                modifier = Modifier
                    .fillMaxWidth(),
                title = Strings.current().apply,
                buttonType = ButtonTypes.CONTAINED,
                onButtonClick = {
                    submitFilterItems()
                },

            )


        }


    }





}